import apiCall from '../components/apiCall';
import { UPDATE_GHETTORADIO_GROUPS, UPDATE_GHETTORADIO_TIMER, UPDATE_GHETTORADIO_LOCKED, UPDATE_GHETTORADIO_HANDLING_ACTION } from './types';

const lockStepTwo = () => dispatch => {
  const d = new Date();
  const date = new Date(d.setDate(new Date().getDate() + 100)).toISOString();
  dispatch({ type: UPDATE_GHETTORADIO_HANDLING_ACTION, payload: UPDATE_GHETTORADIO_TIMER });
  apiCall('/ghettoRadioGroup/updateStepOneTimer', date, 'POST')
    .then(() => {
      dispatch({ type: UPDATE_GHETTORADIO_TIMER, payload: date });
    });
};

const unlockStepTwo = () => dispatch => {
  const d = new Date();
  const date = new Date(d.setDate(new Date().getDate() - 100)).toISOString();
  dispatch({ type: UPDATE_GHETTORADIO_HANDLING_ACTION, payload: UPDATE_GHETTORADIO_TIMER });
  apiCall('/ghettoRadioGroup/updateStepOneTimer', date, 'POST')
    .then(() => {
      dispatch({ type: UPDATE_GHETTORADIO_TIMER, payload: date });
    });
};

const toggleStepThree = (locked) => dispatch => {
  dispatch({ type: UPDATE_GHETTORADIO_HANDLING_ACTION, payload: UPDATE_GHETTORADIO_LOCKED });
  apiCall('/ghettoRadioGroup/setGhettoRadioLocked', { locked }, 'POST')
    .then(() => {
      dispatch({ type: UPDATE_GHETTORADIO_LOCKED, payload: locked });
    });
};

const fetchGhettoRadioGroups = () => dispatch => {
  return apiCall('/ghettoRadioGroup/myGroups')
    .then((groups) => { dispatch({ type: UPDATE_GHETTORADIO_GROUPS, payload: groups }); });
};

export default {
  lockStepTwo,
  unlockStepTwo,
  fetchGhettoRadioGroups,
  toggleStepThree,
};



// WEBPACK FOOTER //
// ./src/actions/ghettoRadio.js